
<template>
  <div class="main-container">
    <div class="container" ref="printArea">
      <!-- Header Section -->
      <div class="row">
        <div class="col-lg-12 text-center my-4">
          <h1>{{ $t('schedule.titleTanding') }}</h1>
          <!--p>
            Pendaftaran Kejuaraan Pencak Silat <strong>[Nama Kejuaraan]</strong> Telah Dibuka! 
            Jangan Lewatkan Kesempatan untuk Bertanding dengan Atlet-Atlet Berbakat Lainnya. 
            Dapatkan Hadiah Menarik dan Sertifikat Peserta!
          </p>
          <button class="btn btn-danger mt-3" @click="downloadPDF">
            <i class="bi bi-download"></i> Export PDF
          </button-->
        </div>
      </div>
      <!--
        PENYARING — satu dropdown per sumbu.

        Sebelumnya tiap sumbu berupa deretan kotak centang plus satu kotak
        "pilih semua". Pada acara sungguhan itu berarti puluhan kotak
        berjejer di atas tabel: empat tanggal, beberapa gelanggang, belasan
        pool, dan enam babak. Panitia harus memindai semuanya untuk tahu apa
        yang sedang aktif, dan mematikan satu pilihan menuntut mencari kotak
        yang tepat di antara puluhan yang mirip.

        Dropdown menyatakan keadaannya dalam satu baris terbaca: "Semua
        gelanggang" atau nama satu gelanggang. Kosong berarti semua.
      -->
      <div class="row filter mb-3">
        <div class="col-lg-12">
          <div class="jadwal-saring-baris">
            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterDate') }}</span>
              <select v-model="filterTanggal" class="form-select">
                <option value="">{{ $t('schedule.allDates') }}</option>
                <option v-for="date in allDates" :key="date" :value="date">
                  {{ formatLongDate(date) }}
                </option>
              </select>
            </label>

            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterArena') }}</span>
              <select v-model="filterArena" class="form-select">
                <option value="">{{ $t('schedule.allArenas') }}</option>
                <option v-for="arena in allArenaNames" :key="arena" :value="arena">
                  {{ arena }}
                </option>
              </select>
            </label>

            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterPool') }}</span>
              <select v-model="filterPool" class="form-select">
                <option value="">{{ $t('schedule.allPools') }}</option>
                <option v-for="pool in allPoolNames" :key="pool" :value="pool">
                  {{ pool }}
                </option>
              </select>
            </label>

            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterRound') }}</span>
              <select v-model="filterBabak" class="form-select">
                <option value="">{{ $t('schedule.allRounds') }}</option>
                <option v-for="round in allRoundLabels" :key="round" :value="round">
                  {{ round }}
                </option>
              </select>
            </label>

            <button
              v-if="adaSaringAktif"
              type="button"
              class="btn btn-outline-secondary jadwal-saring-reset"
              @click="kosongkanSaring"
            >
              <i class="bi bi-x-lg"></i> Tampilkan semua
            </button>
          </div>
        </div>
      </div>

      <!-- Schedule Table -->
      <div class="row bg-white">
        <div class="col-lg-12">
          <div class="table-responsive">
            <div v-if="memuat" class="text-center text-muted my-5">
              <div class="spinner-border" role="status"></div>
              <div class="mt-2">Memuat jadwal…</div>
            </div>

            <div v-else-if="galat" class="alert alert-danger my-4">
              <strong>Jadwal gagal dimuat.</strong>
              <div>{{ galat }}</div>
            </div>

            <!--
              Dua keadaan kosong yang berbeda, dan bedanya penting.
              "Belum ada jadwal" berarti panitia memang belum menyusunnya.
              "Tidak ada yang cocok" berarti jadwalnya ada tapi tersaring —
              dan yang dibutuhkan cuma menekan tombol di bawah.
            -->
            <div v-else-if="!scheduleData.length" class="text-center text-muted my-5">
              <h5>Belum ada jadwal pertandingan yang tersedia.</h5>
              <p class="mb-0">Jadwal akan muncul di sini setelah panitia menyusunnya.</p>
            </div>

            <div v-else-if="!filteredScheduleData.length" class="text-center text-muted my-5">
              <h5>Tidak ada partai yang cocok dengan penyaring.</h5>
              <button type="button" class="btn btn-outline-secondary mt-2" @click="kosongkanSaring">
                <i class="bi bi-x-lg"></i> Tampilkan semua
              </button>
            </div>

            <!-- Arena Loop -->
            <div v-for="arena in filteredScheduleData" :key="arena.arena_name">
              <!-- ✅ Header Arena -->
              <div class="row align-items-center mb-4">
                <div class="col-3 text-start">
                  <img src="@/assets/images/ipsi.png" alt="Logo IPSI" class="logo-ipsi" />
                </div>

                <div class="col-6 text-center">
                  <h4 class="text-dark mb-2 text-uppercase fw-bold">
                    JADWAL {{ arena.arena_name }}
                  </h4>
                  <h4 class="text-dark mb-2 text-uppercase fw-bold">{{ arena.tournament_name }}</h4>
                  <div class="text-dark text-uppercase fw-bold">
                    {{ formatLongDate(arena.scheduled_date) }}
                  </div>
                </div>
                <div class="col-3 text-end">
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click="downloadSchedule(arena)"
                  >
                    <i class="bi bi-download me-1"></i> Download Schedule
                  </button>
                </div>
              </div>

              <!-- ✅ Semua pertandingan langsung ditampilkan -->
              <div class="mb-4">
                <table class="table table-striped">
                  <thead>
                    <tr class="table-sub-header">
                      <th>Partai</th>
                      <th>Babak</th>
                      <th class="text-uppercase text-center">Kelas</th>
                      <th class="text-uppercase text-center">Kategori Usia</th>
                      <th>Pool</th>
                      <th class="text-uppercase text-center red">Merah</th>
                      <th class="text-uppercase text-center blue">Biru</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(match, i) in arena.matches"
                      :key="i"
                    >
                      <td>{{ match.match_number }}</td>
                      <td>{{ match.round_label }}</td>
                      <td class="text-center">{{ match.class_only || match.class_name || '-' }}</td>
                      <td class="text-center">{{ match.age_category_name || '-' }}</td>
                      <td>{{ formatPoolName(match.pool_name) }}</td>
                      <td class="text-center">
                        <div class="text-center font-red">{{ match.participant_two }}</div>
                        <div class="text-center text-success" v-if="match.contingent_two && match.contingent_two !== '-'">{{ match.contingent_two }}</div>
                      </td>
                      <td class="text-center">
                        <div class="text-center font-blue">{{ match.participant_one }}</div>
                        <div class="text-center text-success" v-if="match.contingent_one && match.contingent_one !== '-'">{{ match.contingent_one }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>




          </div>
        </div>
      </div>

    
    </div>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";
import html2pdf from "html2pdf.js";

export default {
  name: "SchedulePage",
  /*
   * Slug bisa datang dari DUA arah:
   *   - alamat /schedule/<slug>/tanding  (tautan yang dibagikan pelatih)
   *   - prop, saat komponen ini dipasang di dalam halaman Jadwal terpadu
   *
   * Prop diutamakan. Tanpa ini, memasangnya di halaman Jadwal akan membaca
   * $route.params.slug yang kosong, dan tabelnya selamanya tidak terisi.
   */
  props: {
    slug: { type: String, default: '' },
  },

  watch: {
    // Berganti acara lewat penyaring tidak mengganti komponen, jadi
    // datanya harus diambil ulang secara manual.
    slugAktif(baru) {
      if (baru) this.fetchSchedules();
    },
  },
  data() {
    return {
      scheduleData: [],
      memuat: true,
      galat: null,

      allArenaNames: [],
      allPoolNames: [],
      allRoundLabels: [],
      allDates: [],

      /*
       * Satu nilai per sumbu; string kosong berarti "semua".
       *
       * Sebelumnya tiap sumbu berupa array pilihan tercentang. Bentuk itu
       * punya jebakan yang tidak kelihatan: array KOSONG berarti "tidak ada
       * yang lolos", sehingga menghapus centang terakhir mengosongkan
       * seluruh tabel — tampak persis seperti jadwal yang hilang.
       */
      filterTanggal: '',
      filterArena: '',
      filterPool: '',
      filterBabak: '',
    };
  },

  computed: {
    /*
     * Slug bisa datang dari alamat (/schedule/<slug>/tanding) atau dari
     * prop, saat komponen ini dipasang di halaman Jadwal terpadu.
     * Prop diutamakan.
     */
    slugAktif() {
      return this.slug || this.$route.params.slug || '';
    },

    adaSaringAktif() {
      return Boolean(
        this.filterTanggal || this.filterArena || this.filterPool || this.filterBabak
      );
    },

    filteredScheduleData() {
      // Kosong berarti "semua" — bukan "tidak ada satu pun".
      const lolos = (dipilih, nilai) => !dipilih || dipilih === nilai;

      return this.scheduleData
        .filter(arena =>
          lolos(this.filterArena, arena.arena_name) &&
          lolos(this.filterTanggal, arena.scheduled_date)
        )
        .map(arena => {
          /*
           * Server mengirimnya bertingkat: arena -> kelompok usia -> babak
           * -> partai. Tabelnya butuh satu daftar datar, jadi diratakan di
           * sini. `?? []` di tiap tingkat penting: satu tingkat yang kosong
           * cukup untuk melempar galat dan mengosongkan seluruh halaman.
           */
          const semuaPartai = (arena.age_category_rounds ?? []).flatMap(kategori =>
            (kategori.rounds ?? []).flatMap(babak =>
              (babak.matches ?? [])
                .map(partai => ({ ...partai, round_label: babak.round_label }))
                .filter(partai =>
                  lolos(this.filterPool, partai.pool_name) &&
                  lolos(this.filterBabak, partai.round_label)
                )
            )
          );

          semuaPartai.sort((a, b) => (a.match_order ?? 0) - (b.match_order ?? 0));

          return { ...arena, matches: semuaPartai };
        })
        .filter(arena => arena.matches.length > 0);
    },






  },

  mounted() {
    this.fetchSchedules();
  },

  methods: {
    groupByAgeCategory(matches) {
      const grouped = {};

      matches.forEach(match => {
        const key = match.age_category_id;
        if (!grouped[key]) {
          grouped[key] = {
            age_category_id: match.age_category_id,
            age_category_name: match.age_category_name,
            matches: []
          };
        }
        grouped[key].matches.push(match);
      });

      // Urutkan berdasarkan age_category_id
      return Object.values(grouped).sort((a, b) => a.age_category_id - b.age_category_id);
    },
    downloadSchedule(arena) {
      // Misalnya lu redirect ke API atau generate PDF
      const params = new URLSearchParams({
        arena_name: arena.arena_name,
        scheduled_date: arena.scheduled_date,
        _t: Date.now(),
      });

      const url = `${API.API_BASE_URL}/tanding/export-schedule?${params.toString()}`;
      window.open(url, '_blank');
    },


    formatLongDate(dateStr) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateStr).toLocaleDateString('id-ID', options);
    },
    formatPoolName(name) {
      if (!name || name === '-') return '-';
      const trimmed = String(name).trim();
      const match = trimmed.match(/^(Pool\s+[A-Za-z0-9]+)/i);
      if (match) {
        let pool = match[1];
        const numMatch = pool.match(/^Pool\s+(\d+)$/i);
        if (numMatch) {
          const n = parseInt(numMatch[1], 10);
          if (n >= 1 && n <= 26) pool = 'Pool ' + String.fromCharCode(64 + n);
        }
        return pool;
      }
      return trimmed.split('-')[0].trim();
    },

    kosongkanSaring() {
      this.filterTanggal = '';
      this.filterArena = '';
      this.filterPool = '';
      this.filterBabak = '';
    },

    async fetchSchedules() {
      this.memuat = true;
      this.galat = null;

      try {
        const slug = this.slugAktif;

        if (!slug) {
          this.scheduleData = [];
          return;
        }

        const response = await axios.get(`/tournaments/${slug}/match-schedules/tanding`);
        this.scheduleData = Array.isArray(response.data?.data) ? response.data.data : [];

        const pools = new Set();
        const babak = new Set();

        this.scheduleData.forEach(item => {
          (item.age_category_rounds ?? []).forEach(kategori => {
            (kategori.rounds ?? []).forEach(r => {
              if (r.round_label) babak.add(r.round_label);
              (r.matches ?? []).forEach(m => {
                if (m.pool_name) pools.add(m.pool_name);
              });
            });
          });
        });

        this.allArenaNames = [...new Set(this.scheduleData.map(i => i.arena_name).filter(Boolean))];
        this.allDates = [...new Set(this.scheduleData.map(i => i.scheduled_date).filter(Boolean))];
        this.allPoolNames = [...pools];
        this.allRoundLabels = [...babak];

        /*
         * Pilihan yang sudah tidak ada di acara ini dilepas.
         * Tanpa ini, berpindah acara membawa serta nama gelanggang acara
         * sebelumnya, dan tabelnya kosong tanpa alasan yang terlihat.
         */
        if (this.filterArena && !this.allArenaNames.includes(this.filterArena)) this.filterArena = '';
        if (this.filterTanggal && !this.allDates.includes(this.filterTanggal)) this.filterTanggal = '';
        if (this.filterPool && !this.allPoolNames.includes(this.filterPool)) this.filterPool = '';
        if (this.filterBabak && !this.allRoundLabels.includes(this.filterBabak)) this.filterBabak = '';
      } catch (error) {
        console.error("Gagal ambil jadwal:", error);
        this.scheduleData = [];
        this.galat = error?.response?.data?.message || error?.message || 'Gagal memuat jadwal.';
      } finally {
        this.memuat = false;
      }
    },


    downloadPDF() {
      const element = this.$refs.printArea;
      const options = {
        filename: 'jadwal-pertandingan.pdf',
        margin: 0.3,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };
      html2pdf().set(options).from(element).save();
    }
  },
};
</script>

<style scoped>
/* Penyaring: satu baris yang membungkus sendiri di layar sempit. */
.jadwal-saring-baris {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
}

.jadwal-saring-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1 190px;
  min-width: 160px;
  font-size: 0.9rem;
}

.jadwal-saring-reset { flex: 0 0 auto; }

/*
 * Gaya halaman ini dipindah ke src/assets/css/jadwal.css.
 * Alasannya: kelima halaman jadwal menyalin blok yang sama persis, sehingga
 * setiap perbaikan harus dikerjakan lima kali dan mudah tertinggal di salah
 * satunya. Berkas bersama juga tidak "scoped", jadi ia sanggup menjangkau
 * tabel Bootstrap yang dirender di dalam komponen anak.
 */
</style>
